@if (content) {
<footer class="bg-col-1 page-footer col-w">
    <!-- XL / footer top -->
    <div *ifSize="'XL'"
         [bottomPanelArea]="'footer'">
        <ng-container *ngTemplateOutlet="bannerTmpl; context: {$implicit: content}"></ng-container>
        <div class="wrap p-t-10 p-b-10">
            <div class="flex flex-justify-between">
                @for (menu of content.menus; track $index; let isFirst = $first; let isLast = $last; let
                i = $index) {
                <div class="m-b-0">
                    <!-- heading -->
                    <h3 class="s1 col-w"
                        *iCms="'heading' of menu"></h3>
                    <!-- links  -->

                    <ng-container *ngTemplateOutlet="menuTmpl; context: { $implicit: menu, i }"></ng-container>
                </div>
                }
            </div>

            <div class="flex flex-justify-between m-t-8">
                <div>
                    <img src="assets/icons/logo-secondary.png"
                         style="width: 220px; height: 51px;object-fit: contain;"
                         alt="logo"
                         class="va-m inline-block m-t-7">
                </div>
                <ng-container *ngTemplateOutlet="socialTmpl"></ng-container>
            </div>
        </div>
    </div>

    <!-- MS / footer top -->
    <div *ifSize="'MS'">
        <ng-container *ngTemplateOutlet="bannerTmpl; context: {$implicit: content}"></ng-container>
        <div class="flex flex-column-reverse m-r m-l col-w bg-col-1">
            <div class="p-t-8 p-b">
                <ng-container *ngTemplateOutlet="socialTmpl"></ng-container>
            </div>
            <div class="bg-col-1 col-w w-12 b-t">
                @for (menu of content.menus; track $index; let isFirst = $first; let isLast = $last; let
                i =
                $index) {
                <div [bottomPanelArea]="'footer'">
                    <expandable [whiteMode]="true"
                                [expandableTitle]="menu.heading"
                                [expandableId]="['footer', i]"
                                [toggleState]="i === 4 ? true : false">
                        <ng-container *ngTemplateOutlet="menuTmpl; context: { $implicit: menu, i }"></ng-container>
                    </expandable>

                </div>
                }
            </div>
        </div>
    </div>
    <!-- footer bottom -->
    <!-- payment icons -->
    <div *ifSize="'XL'"
         class="w-12 bg-col-51 flex flex-middle flex-justify-between p-r-10-x p-l-10-x p-r-10-l p-l-10-l p-t-1 p-b-1">
        <div class="w-5">
            @for (method of content.payment_options; track $index) {
            <payment-icon [method]="method.payment_logo"
                          [style.fontSize.px]="20"
                          class=" m-r-3"></payment-icon>
            }
        </div>

        <!-- Here should be the trustpilot widget-->
        <div class="ratio-10-1">
            <href [link]="content.trustImageLink">
                <img [ratio]="'ratio-10-1'"
                     [dfImage]="content.trustImage"
                     alt="Trustpilot"
                     [loaderParams]="{fitIn: true, fillColor: 'transparent'}"
                     style="height: 41px"
                     class="va-m inline-block">
            </href>
        </div>

        <div class="w-5">
            <!-- links -->
            <ul class="flex flex-grow flex-top flex-justify-end m-t-4-s">
                @for (item of content.bottomLinks; track $index) {
                <li class="m-l-2 m-r-2">
                    <href [link]="item.link">
                        <span class="c2 col-4 _footer-link"
                              *iCms="'text' of item">
                        </span>
                    </href>
                </li>
                }
            </ul>
        </div>
    </div>
    <div *ifSize="'MS'"
         class="bg-col-51  p-t-3 p-b-3">
        <div class="w-12 flex">
            <div class="w-6 flex flex-wrap flex-justify-center">
                @for (method of content.payment_options; track $index) {
                <payment-icon [method]="method.payment_logo"
                              [style.fontSize.px]="20"
                              class=" m-r-3"></payment-icon>
                }
            </div>

            <!-- Here should be the trustpilot widget-->
            <div class="w-6 flex-m flex-justify-center">
                <href [link]="content.trustImageLink">
                    <img [dfImage]="content.trustImage"
                         alt="Trustpilot"
                         [width]="85"
                         [height]="41"
                         [loaderParams]="{fitIn: true, fillColor: 'transparent'}"
                         style="height: 41px;"
                         class="va-m inline-block">
                </href>
            </div>
        </div>
        <div class="w-12">
            <!-- links -->
            <ul class="flex flex-top flex-justify-center m-t">
                @for (item of content.bottomLinks; track $index) {
                <li class="m-l-2 m-r-2">
                    <href [link]="item.link">
                        <span class="c1 col-12"
                              *iCms="'text' of item">
                        </span>
                    </href>
                </li>
                }
            </ul>
        </div>
    </div>
</footer>
<!-- ------- TEMPLATES ----------- -->
<!-- template / MENU -->
<ng-template #menuTmpl
             let-menu
             let-index="i">
    @if(index === 4) {
    <ng-container *ngTemplateOutlet="contactUsTmpl; context: { $implicit: content }"></ng-container>
    }
    <ul class="p-t">
        @for (item of menu.items; track $index; let isFirst = $first; let isLast = $last;) {
        <href [link]="item.link">
            <li [ngClass]="{'m-t-2': !isFirst}"
                class="_footer-menu-link">
                @if (item.icon) {
                <span class="m-r-2"
                      [lineHeightBy]="'p2'">
                    <i [style.font-size.px]="18"
                       [ngClass]="item.icon"></i>
                </span>
                }
                <span sizeClass="SM:p1, XL:p2"
                      class="inline-block va-m _copy"
                      *iCms="'text' of item"></span>
            </li>
        </href>
        }
    </ul>
</ng-template>

<!-- template / SOCIAL  -->
<ng-template #socialTmpl>
    <div *ifSize="'XL'">
        <div class="w-12 flex flex-middle">
            <div class="flex flex-middle">
                <span class="s1 col-w m-r">{{'Folow Us' | translate}}</span>
                @for (service of content.socialServices; track $index; let last = $last) {
                <a [attr.href]="service.link"
                   target="_blank"
                   class="_footer-menu-link"
                   rel="nofollow"
                   [attr.aria-label]="service.name"
                   [class.m-r]="!last">
                    <!-- icon -->
                    <i [ngClass]="service.icon"
                       aria-hidden="true"></i>
                </a>
                }

                @if(content.certifications?.length) {
                <div class="flex flex-middle"
                     style="margin-left: 60px;">
                    <span class="s1 col-w m-r">{{'Certifications' | translate}}</span>
                    <div class="flex ">
                        @for(icon of content.certifications; track $index; let isFirst = $first;
                        let isLast =
                        $last;){
                        <div>
                            <img [attr.alt]="icon.alt"
                                 [width]="135"
                                 [height]="77"
                                 [dfImage]="icon.image" />
                        </div>
                        }
                    </div>
                </div>
                }

                @if(content.members?.length) {
                <div class="flex flex-middle"
                     style="margin-left: 60px;">
                    <span class="s1 col-w m-r">{{'Members of' | translate}}</span>
                    <div class="flex ">
                        @for(icon of content.members; track $index; let isFirst = $first;
                        let isLast =
                        $last;){
                        <div>
                            <img [attr.alt]="icon.alt"
                                 [width]="228"
                                 [height]="77"
                                 [dfImage]="icon.image" />
                        </div>
                        }
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    <div *ifSize="'MS'">
        <div class="flex flex-justify-between-s flex-justify-around-m">
            @if(content.certifications?.length) {
            <div class="flex flex-column flex-middle">
                <span class="s2 col-w m-b-2">{{'Certifications' | translate}}</span>
                <div class="flex">
                    @for(icon of content.certifications; track $index; let isFirst = $first; let
                    isLast =
                    $last;){
                    <div>
                        <img [attr.alt]="icon.alt"
                             [width]="125"
                             [height]="47"
                             [dfImage]="icon.image" />
                    </div>
                    }
                </div>
            </div>
            }
            @if(content.members?.length) {
            <div class="flex flex-column flex-middle">
                <span class="s2 col-w m-b-2">{{'Members of' | translate}}</span>
                <div class="flex">
                    @for(icon of content.members; track $index; let isFirst = $first; let isLast = $last;){
                    <div>
                        <img [attr.alt]="icon.alt"
                             [width]="155"
                             [height]="47"
                             [dfImage]="icon.image" />
                    </div>
                    }
                </div>
            </div>
            }

        </div>
        <div class="flex flex-middle flex-justify-between-s flex-justify-around-m m-t-8">
            <div>
                <img src="assets/icons/logo-secondary.png"
                     style="width: 100px; height: 47px;object-fit: contain;"
                     alt="logo"
                     class="va-m inline-block m-t-5-x m-t-5-l">
            </div>
            @if (content.socialServices && content.socialServices.length) {
            <div>
                @for (service of content.socialServices; track $index; let last = $last) {
                <a [attr.href]="service.link"
                   target="_blank"
                   rel="nofollow"
                   [attr.aria-label]="service.name"
                   [class.m-r]="!last">
                    <!-- icon -->
                    <i [ngClass]="service.icon"
                       aria-hidden="true"></i>
                </a>
                }
            </div>
            }
        </div>
    </div>
</ng-template>

<!-- template / BANNER  -->
<ng-template #bannerTmpl
             let-content>
    @if(!app.customer.model?.isLoggedIn){
    <div class="flex flex-middle-x flex-middle-l w-12 bg-col-62">
        <div class="w-62 w-12-s w-12-m p-t p-b right-x right-l">
            <div class="_bannerText inline-block left">
                <span class="h3 col-w"
                      *iCms="'bannerHeading' of content"></span>
                <p sizeClass="SM:p2, XL:p1"
                   class="col-w m-t-3"
                   *iCms="'bannerText' of content"></p>
                <href [link]="content.buttonCtaLink">
                    <button [buttonStyle]="content?.buttonStyle || 'button-2'"
                            class="col-1 m-t">
                        <span class="button-label"
                              *iCms="'buttonCtaCopy' of content"></span>
                    </button>
                </href>
            </div>
        </div>
        @if(!client.isS && !client.isM){
        <div class="w-6">
            <!-- image  -->
            <ng-container>
                <div [ngClass]="content?.ratio || ''">
                    <img class="z-1 w-12"
                         [fill]="true"
                         [ratio]="content?.ratio || 1"
                         [dfImage]="content?.background_image">
                </div>
            </ng-container>
        </div>
        }
    </div>
    }
</ng-template>

<!-- template / CONTACT  -->
<ng-template #contactUsTmpl
             let-content>
    <div class="m-t">
        <div class="s2 m-b-2">{{'Opening Hours' | translate}}</div>
        @for(hours of content?.workingHours; track $index; let isLast = $last;) {
        <div [ngClass]="{'m-b-2': !isLast}"
             sizeClass="SM:p1, XL:p2"
             *iCms="'text' of hours"></div>
        }
    </div>
</ng-template>
}
